import React, { useEffect, useState } from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';

export const FilterLink = ({
  children,
  clickable = false,
  onClick
}: {
  children: React.ReactNode;
  clickable?: boolean;
  onClick?: () => void;
}) => (
  <Text
    variant="body1"
    sx={{
      color: colors.darkBlue,
      textDecoration: 'underline',
      cursor: clickable ? 'pointer' : 'default',
      display: 'inline'
    }}
    onClick={onClick}
  >
    {children}
  </Text>
);

const COLLAPSED_FILTER_THRESHOLD = 2;

export const useFilterRendering = (filters: string[]) => {
  const [showOtherFilters, setShowOtherFilters] = useState(false);

  useEffect(() => {
    setShowOtherFilters(false);
  }, [filters]);

  const renderFilters = (activeFilters: string[]) => {
    const shouldShowCollapsed = activeFilters.length > COLLAPSED_FILTER_THRESHOLD && !showOtherFilters;
    const filtersToShow = shouldShowCollapsed ? activeFilters.slice(0, COLLAPSED_FILTER_THRESHOLD) : activeFilters;
    const elements = [];

    filtersToShow.forEach((filter, index) => {
      elements.push(<span key={filter}>{filter}</span>);

      if (index < filtersToShow.length - 1) {
        if (index === filtersToShow.length - 2 && !shouldShowCollapsed) {
          elements.push(<span key={`separator-${index}`}> and </span>);
        } else {
          elements.push(<span key={`separator-${index}`}>, </span>);
        }
      }
    });

    if (shouldShowCollapsed) {
      elements.push(<span key="and"> and </span>);
      elements.push(
        <FilterLink key="others" clickable onClick={() => setShowOtherFilters(true)}>
          others
        </FilterLink>
      );
    }

    return elements;
  };

  return { renderFilters };
};
